module.exports = __webpack_public_path__ + "media/images/pear-6-784cdb1020f7fddb86f414f895cbb170.png";